export const ORDER_BY_VALUES = {
  UPDATED_AT_ASC: 'updatedAt.asc',
  UPDATED_AT_DESC: 'updatedAt.desc',
  CREATED_AT_ASC: 'createdAt.asc',
  CREATED_AT_DESC: 'createdAt.desc',
  NAME_ASC: 'name.asc',
  NAME_DESC: 'name.desc',
};
